import { globalObject } from './globalObject';
export function sendToExtension(type, payload) {
  var callback = globalObject.__ddBrowserSdkExtensionCallback;
  if (callback) {
    callback({
      type: type,
      payload: payload
    });
  }
}